<template>
  <div class="page-eddid-bank-account  card-shadow--small">
    <el-card>
      <div class="pl-20 pr-20 bank-icon">
        <div>
          <img :src="accountInfo.icon" width="50" height="50" alt="">
          <span :test_id="'personal_bank_info_' + accountInfo.acc_num">{{accountInfo.title}} <br> <b>{{accountInfo.acc_num}}</b></span>
        </div>
        <span class="yz-text">{{accountInfo.bankType==='BANK_SECURITIES_TRANSFER'?$t('common.yztransfer'):''}}</span>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    step: Object,
    accountInfo: Object
  },
  computed: {
  },
  data () {
    return {}
  }
}
</script>
<style lang='scss' scoped>
.pt-10{
  padding-top: 15px;
}
pl-20{
  padding-left: 20px;
}
pr-20{
  padding-right: 20px;
}
.page-eddid-bank-account {
  border-radius: 10px;
  margin-bottom: 15px;
  .el-card {
    border-radius: 10px;
  }
  .bank-card {
    margin-top: 1.5rem;
  }
  .el-card__body {
    position: relative;
    padding: 30px 0;
    padding-left: 88px;
    .img-div {
      position: absolute;
      top: 50%;
      left: 0;
      width: 88px;
      transform: translateY(-50%);
      border-radius: 50% !important;
      img {
        margin: 0 auto;
        width: 3rem !important;
        vertical-align: middle;
      }
    }
    .account-div {
      display: inline-block;
      .eddid-bank-name {
        font-family: Muli-Bold;
        font-size: 14px;
        color: #666666;
        letter-spacing: 0.17px;
      }
      .eddid-bank-number {
        font-family: Muli-Bold;
        font-size: 16px;
        color: #24282d;
        letter-spacing: 0.14px;
        padding-top: 10px;
      }
    }
  }
  .bank-icon{
    color: #666666;
    position: relative;
    img, span{
      display: inline-block;
      vertical-align: middle;
      height: 50px;
      line-height: 25px;
      padding-right: 10px;
    }
    span{
      b{
        color: #24282d;
      }
    }
    .yz-text{
      position: absolute;
      right: 20px;
      bottom: 0;
      font-size: 14px;
      line-height: 50px;
    }
  }
}
@media only screen and (max-width: 660px) {
  .page-eddid-bank-account .el-card__body .img-div img {
    width: 3rem !important;
  }
}

</style>
